import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Button } from "react-bootstrap";

const LockButton = ({
  lockFn,
  locked
}) => /*#__PURE__*/React.createElement(Button, {
  variant: 'outline-secondary',
  active: locked,
  onClick: () => lockFn(),
  title: locked ? 'Unlock' : 'Lock'
}, /*#__PURE__*/React.createElement(FontAwesome, {
  name: locked ? 'unlock' : 'lock'
}));

export default LockButton;